export enum AutoAssignEnum {
  OnSpecificDate = 'ON_SPECIFIC_DATE',
  Never = 'NEVER',
}
